import React from "react";
import { styled, LinearProgress, useTheme } from "@mui/material";

const StyledLinearProgress = styled((props) => (
  <LinearProgress variant="determinate" {...props} />
))(({ theme }) => [
  {
    "& .MuiLinearProgress-bar1": {
      background: `linear-gradient(90deg, ${theme.branding.cyan[200]} 10%, ${theme.branding.cyan[300]} 60%, ${theme.branding.cyan[600]} 100%)`,
    },
  },
  theme.applyStyles("dark", {
    backgroundColor: theme.branding.darkBlue[600],
  }),
]);

const LinearProgressBar = (props) => {
  const { max, value, sx } = props;
  const theme = useTheme();

  return (
    <StyledLinearProgress
      min={0}
      max={max}
      value={value}
      sx={{
        ...sx,
        width: "100%",
        borderRadius: "4px",
        backgroundColor: theme.branding.gray[200],
      }}
    />
  );
};

export default LinearProgressBar;
